import * as types from "../types";

const initialState = {
    get: {
        docs: [],
        page: 1,
        pages: 1,
        limit: 10,
        total: 0
    }
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_CONTACTS:
            return { ...state, get: action.payload };

        default:
            return { ...state };
    }
};

export default reducer;
